var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import styles from "./SendForm.module.scss";
import { isEmpty } from "lodash";
import { getSettings } from "../../constants/setting";
import { getTranslation } from "../../constants/setting";
import { getTextColor } from "../../helper";
import { sendMessage } from "../../stores/reducers/chatReducer";
import { MESSAGE_TYPE_CONTACT_FORM } from "../../constants";
import { useDispatch } from "react-redux";
import { isLanguageRTL } from "../../../../constants";
var SendForm = function (props) {
    var sendInquiry = props.sendInquiry;
    var dispatch = useDispatch();
    var _b = useState(''), text = _b[0], setText = _b[1];
    var primary_color = getSettings().primary_color;
    var _j = getSettings(), enable_contact_us_form = _j.enable_contact_us_form, topics = _j.topics, enable_contact_button_on_send_form = _j.enable_contact_button_on_send_form, language = _j.language;
    var prepareSubmit = function (e) {
        e.preventDefault();
        if (!isEmpty(text.trim())) {
            sendInquiry(text.trim());
            setText('');
        }
    };
    var showContactForm = function () {
        dispatch(sendMessage({
            response: {
                type: MESSAGE_TYPE_CONTACT_FORM,
                language: language,
                data: {
                    text: getTranslation('chatbot.send_contact_form') + ':',
                    show: true,
                    submitted: false,
                    language: language,
                    topics: topics
                }
            }
        }));
    };
    return _jsx("div", __assign({ className: "".concat(styles.sendForm, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: _jsxs(Form, __assign({ onSubmit: prepareSubmit }, { children: [_jsx(Form.Label, __assign({ htmlFor: "question", className: styles.srOnly }, { children: getTranslation('chatbot.type_question_here') })), _jsxs(InputGroup, { children: [_jsx(Form.Control, { className: styles.sendFormField, placeholder: getTranslation('chatbot.question') + '...', id: "question", value: text, minLength: 5, maxLength: 2500, onChange: function (e) { return setText(e.target.value); } }), _jsx(Button, __assign({ className: styles.sendButton, type: "submit", variant: "primary", id: "send_inquiry", style: {
                                backgroundColor: primary_color,
                                borderColor: primary_color,
                                color: getTextColor(primary_color)
                            } }, { children: getTranslation('chatbot.send') })), enable_contact_us_form && enable_contact_button_on_send_form ? _jsxs(Button, __assign({ className: styles.contactBtnTrigger, type: "button", title: getTranslation('chatbot.send_contact_form'), onClick: showContactForm }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", width: "20", height: "20" }, { children: _jsx("path", { d: "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z" }) })), _jsx("div", __assign({ className: styles.label }, { children: getTranslation('chatbot.send_contact_form') }))] })) : null] })] })) }));
};
export default SendForm;
